import React, { useCallback, useMemo } from 'react';
import { makeStyles, Container, Grid, Paper } from '@material-ui/core';
import BreadCrumb from 'app/components/BreadCrumb';
import { injectIntl } from 'react-intl';

import { FormServiceContext } from 'app/utils/contexts';
import InspectionReportRegistration from 'app/components/ServicesForms/InspectionReportRegistration';
import withRequestInitiation from 'app/components/Hoc/withRequestInitiation';

import { useDispatch, useSelector } from 'react-redux';

import surveyEndpoint from 'app/api/services/surveyEndpoint';
import { hideLoading, showLoading } from 'app/store/slices/settings';
import notification from 'app/config/notification';
import { errorHandler } from 'app/utils/errorHandler';
import { SERVICES_PROPERTIES } from 'app/config/services';

import styles from './styles';
const useStyles = makeStyles(styles);

function InspectionReport(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const service = useSelector(state => state.services.details);

  const {
    intl,
    loadingDocuments,
    setLoadingDocuments,
    canEdit,
    resetAndGo,
    onCancel,
    validateForm,
    breadCrumb,
    rightInfo,
    handleOnBack,
  } = props;

  const onSubmit = useCallback(
    async (request, survey) => {
      let errors = false;
      if(!survey || !survey.vistoriaVeiculos || survey.vistoriaVeiculos.length === 0){
        errors = true;
      }else{
        survey.vistoriaVeiculos.forEach(vv => {
          if(!vv.tpSituacao){
            errors = true;
            return;
          }
        });
      }

      if(errors){
        notification(
          intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_REPORT_TO_SEND' }),
          { toastId: 'MISSING_REPORT_TO_SEND', type: 'error' }
        );
        return;
      }

      if (!canEdit) {
        if (request.situacao && !request.situacao?.boEdicaoPortalExterno) return;
      }
      dispatch(showLoading());
      if (request?.cdSolicitacao) {
        try {
          const response = await surveyEndpoint.sendInspectionReport(request?.cdSolicitacao);
          if (response.status === 200) {
            notification(
              intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.INSPECTION_REPORT_SENT' }),
              { toastId: 'INSPECTION_REPORT_SENT', type: 'success' }
            );
          }
          resetAndGo();
        } catch (error) {
          errorHandler(error.response?.status, error.response?.data?.message);
        }
      }
      dispatch(hideLoading());
    },
    [canEdit, dispatch, intl, resetAndGo]
  );

  const contextProvider = useMemo(() => {
    return {
      loadingDocuments,
      setLoadingDocuments,
      validateForm,
      onCancel,
      onSubmit,
      validationSchema: SERVICES_PROPERTIES[service.cdServico]
        ? SERVICES_PROPERTIES[service.cdServico].validationSchema
        : {},
      canEdit,
    };
  }, [
    loadingDocuments,
    setLoadingDocuments,
    validateForm,
    onCancel,
    onSubmit,
    service.cdServico,
    canEdit,
  ]);

  return (
    <Container>
      <BreadCrumb onBack={handleOnBack} breadCrumb={breadCrumb} rightInfo={rightInfo} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.container} elevation={3}>
            <FormServiceContext.Provider value={contextProvider}>
              <InspectionReportRegistration {...props} />
            </FormServiceContext.Provider>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default injectIntl(withRequestInitiation(InspectionReport));
